import React from 'react'
import arrow from '../../assets/arrow-steps.svg'
import { steps_content } from '../../utils/constant_data';
import './StepsToFollow.scss';

const StepsToFollow = () => {
    
    return (
        <div className='steps'>
            {
                steps_content.map(item => (
                    <RenderCard key={item.number} description={item.description} number={item.number} />
                ))
            }
        </div>
    )
}

function RenderCard(props) {

    const { description, number } = props

    return (
        <div className='steps_item'>
            <div className='steps_item_card'>
                <h1>{number}</h1>
                <p>{description}</p>
            </div>
            { number < 3 ? <img src={arrow} /> : null}
        </div>
    )

}

export default StepsToFollow